
import React, { PureComponent } from 'react';
import { Card, Collapse, Table } from 'antd';
import { Container } from '../../../../components';
import { AppWrappperHOC } from '../../../Root/HOC';
import { StyledAuditCommittee } from '../StyledIPO';
import {
  FINANCIAL_RESULTS_COLUMNS,
  QUARTERLY_FINANCIAL_RESULTS,
  INVESTOR_PRESENTATION,
  PRESS_RELEASE,
  EARNING_CALL_TRANSCRIPT,
  EARNING_CALL_TRANSCRIPT_COLOUMNS,
  INTIMATION_EARNING_CALL,
} from './constants';

const { Panel } = Collapse;

class Financials extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <StyledAuditCommittee>
        <Container>
          <Card className="rounded card-padding-20">
            <h2 className="text-red">Financials</h2>
            <Collapse
              expandIconPosition="right"
              bordered={false}
              className="collapse-grill"
            >
              <Panel
                header={<strong className="font-16">Quarterly Financial Results</strong>}
                key="01"
              >
                <Table
                  columns={FINANCIAL_RESULTS_COLUMNS}
                  dataSource={QUARTERLY_FINANCIAL_RESULTS}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Investor Presentation</strong>}
                key="02"
              >
                <Table
                  columns={FINANCIAL_RESULTS_COLUMNS}
                  dataSource={INVESTOR_PRESENTATION}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Press Release</strong>}
                key="03"
              >
                <Table
                  columns={FINANCIAL_RESULTS_COLUMNS}
                  dataSource={PRESS_RELEASE}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Earning Call Transcript</strong>}
                key="04"
              >
                <Table
                  columns={EARNING_CALL_TRANSCRIPT_COLOUMNS}
                  dataSource={EARNING_CALL_TRANSCRIPT}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Intimation of Earning Call</strong>}
                key="05"
              >
                <Table
                  columns={FINANCIAL_RESULTS_COLUMNS}
                  dataSource={INTIMATION_EARNING_CALL}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
            </Collapse>
          </Card>
        </Container>
      </StyledAuditCommittee>
    );
  }
}

const component = AppWrappperHOC(Financials);

export { Financials };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/Financials/index.jsx